import { render } from "./ServiceLocationDisplay.vue?vue&type=template&id=3bbae5c1&scoped=true"
import script from "./ServiceLocationDisplay.vue?vue&type=script&lang=js"
export * from "./ServiceLocationDisplay.vue?vue&type=script&lang=js"

import "./ServiceLocationDisplay.vue?vue&type=style&index=0&id=3bbae5c1&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bbae5c1"]])

export default __exports__